var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderDetailStatusGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderDetailStatusGetErrors = $event
          }
        }
      }),
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", dense: "", elevation: "0" } },
        [_c("span", [_vm._v("Statuses")])]
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.orderDetailStatusList,
          headers: _vm.headers,
          loading: _vm.orderDetailStatusGetting,
          dense: ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        item.created_at.dateFormat({
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      )
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        item.updated_at.dateFormat({
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      )
                    )
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }